import { getLanguageQueryOptions } from "../../queries/languages";

// language is pre-fetched when a user hover a 'view language' link
export const languageViewLoader = ({ params, context: { queryClient } }) => {
  const { languageId } = params;
  queryClient.ensureQueryData(getLanguageQueryOptions(languageId, queryClient));
};
